 //Start AutoComplite
NHS.Scripts.GoogleMapApi.prototype.initializeAutoComplete = function() {
    var self = this;
    var hasControl = false;
    var placeAutocomplete;

    if (self.options.Autocomplete.CreateControl) {
        placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({});
        placeAutocomplete.placeholder = 'Enter a location';
        self.createControles(placeAutocomplete);
        self.initializeAutoCompleteControles(placeAutocomplete);
        hasControl = true;
    } else {
        var existingControl = document.getElementById(self.options.Autocomplete.Autocompletecontrol);
        if (existingControl) {
            var existingAutocomplete = existingControl.parentNode.querySelector('gmp-place-autocomplete');
            if (existingAutocomplete) {
                placeAutocomplete = existingAutocomplete;
            } else {
                placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({});
                placeAutocomplete.placeholder = 'Enter a location';
                existingControl.parentNode.insertBefore(placeAutocomplete, existingControl);
                existingControl.type = 'hidden';
            }
            hasControl = true;
        }
    }

    if (hasControl) {
        if (self.options.Autocomplete.BindToBound) {
            placeAutocomplete.locationBias = self.map.getBounds();
            google.maps.event.addListener(self.map, 'bounds_changed', function() {
                placeAutocomplete.locationBias = self.map.getBounds();
            });
        }

        var markerContent = document.createElement('div');
        markerContent.style.width = '35px';
        markerContent.style.height = '35px';
        markerContent.style.display = 'none';

        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: self.map,
            content: markerContent,
            gmpClickable: true
        });

        placeAutocomplete.addEventListener('gmp-select', async function(event) {
            var placePrediction = event.placePrediction;
            var place = placePrediction.toPlace();
            await place.fetchFields({
                fields: ['displayName', 'formattedAddress', 'location', 'viewport', 'svgIconMaskURI', 'addressComponents']
            });
            self.placeChangedProcess(marker, place);
        });
    }
};

NHS.Scripts.GoogleMapApi.prototype.placeChangedProcess = function(marker, place) {
    var self = this;
    self.infowindow.close();
    marker.content.style.display = 'none';
    if (!place.location) {
        return;
    }

    // If the place has a geometry, then present it on a map.
    if (place.viewport) {
        self.map.fitBounds(place.viewport);
    } else {
        self.map.setCenter(place.location);
        self.map.setZoom(17); // Why 17? Because it looks good.
    }

    var icon = self.iconAutoComplite(place);
    var markerImg = marker.content.querySelector('img') || document.createElement('img');
    markerImg.src = icon.url;
    markerImg.style.width = icon.scaledSize.width + 'px';
    markerImg.style.height = icon.scaledSize.height + 'px';
    if (!marker.content.contains(markerImg)) {
        marker.content.innerHTML = '';
        marker.content.appendChild(markerImg);
    }
    marker.position = place.location;
    marker.content.style.display = 'block';

    var address = '';
    if (place.addressComponents) {
        address = [
            (place.addressComponents[0] && place.addressComponents[0].shortText || ''),
            (place.addressComponents[1] && place.addressComponents[1].shortText || ''),
            (place.addressComponents[2] && place.addressComponents[2].shortText || '')
        ].join(' ');
    }

    self.infowindow.setContent('<div><strong>' + place.displayName + '</strong><br>' + address);
    self.infowindow.open({
        anchor: marker,
        map: self.map
    });
};

NHS.Scripts.GoogleMapApi.prototype.iconAutoComplite = function(place) {
    var icon = {
        url: place.svgIconMaskURI || '',
        size: new google.maps.Size(71, 71),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(35, 35)
    };
    return icon;
};

NHS.Scripts.GoogleMapApi.prototype.createControles = function(placeAutocomplete) {
    var self = this;
    var newNode = jQuery('<div>' +
        '<div id="type-selector" class="controls">' +
        '<input type="radio" name="type" id="changetype-all" checked="checked">' +
        '<label for="changetype-all">All</label>' +
        '<input type="radio" name="type" id="changetype-establishment">' +
        '<label for="changetype-establishment">Establishments</label>' +
        '<input type="radio" name="type" id="changetype-geocode">' +
        '<label for="changetype-geocode">Geocodes</label>' +
        '</div></div>')[0];
    newNode.insertBefore(placeAutocomplete, newNode.firstChild);
    self._controlNode = newNode;
};

    // Sets a listener on a radio button to change the filter type on Places
    // Autocomplete.
NHS.Scripts.GoogleMapApi.prototype.initializeAutoCompleteControles = function(placeAutocomplete) {
    var self = this;
    var $controlNode = jQuery(self._controlNode);
    $controlNode.find("#changetype-all").change(function() {
        placeAutocomplete.includedPrimaryTypes = [];
    });

    $controlNode.find("#changetype-establishment").change(function() {
        placeAutocomplete.includedPrimaryTypes = ['establishment'];
    });

    $controlNode.find("#changetype-geocode").change(function() {
        placeAutocomplete.includedPrimaryTypes = ['geocode'];
    });
    self.map.controls[google.maps.ControlPosition.TOP_LEFT].push(self._controlNode);
};